import { useGetList } from "ra-core";

import type { Contact, ContactNote } from "../types";
import { DashboardActivityLog } from "./DashboardActivityLog";
import { DashboardStepper } from "./DashboardStepper";
import { DealsChart } from "./DealsChart";
import { LeadTemperatureRadar } from "./LeadTemperatureRadar";
import { MorningPulse } from "./MorningPulse";
import { TasksList } from "./TasksList";
import { Welcome } from "./Welcome";

export const Dashboard = () => {
  const {
    data: dataContact,
    total: totalContact,
    isPending: isPendingContact,
  } = useGetList<Contact>("contacts", {
    pagination: { page: 1, perPage: 1 },
  });

  const { total: totalContactNotes, isPending: isPendingContactNotes } =
    useGetList<ContactNote>("contactNotes", {
      pagination: { page: 1, perPage: 1 },
    });

  const { total: totalDeal, isPending: isPendingDeal } = useGetList<Contact>(
    "deals",
    {
      pagination: { page: 1, perPage: 1 },
    },
  );

  const isPending = isPendingContact || isPendingContactNotes || isPendingDeal;

  if (isPending) {
    return null;
  }

  return (
    <div className="flex flex-col gap-6 mt-1">
      {/* 1. Intelligence Layer: Morning Briefing */}
      <MorningPulse />

      {!totalContact ? (
        <DashboardStepper step={1} />
      ) : (
        <div className="flex flex-col gap-6">
          {/* 2. Visual Layer: Pipeline Radar */}
          <LeadTemperatureRadar />

          {!totalContactNotes ? (
            <DashboardStepper step={2} contactId={dataContact?.[0]?.id} />
          ) : (
            /* 3. Operational Layer: Charts & Lists */
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
              <div className="md:col-span-8 flex flex-col gap-6">
                {totalDeal ? <DealsChart /> : null}
                <DashboardActivityLog />
              </div>

              <div className="md:col-span-4 flex flex-col gap-6">
                {import.meta.env.VITE_IS_DEMO === "true" ? <Welcome /> : null}
                <TasksList />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
